export const getOffsetPosition = (page, pageSize) => {
  return (page - 1) * pageSize;
};
export const getPaginatedPosition = (offsetPosition, indexInPage) => {
  return offsetPosition + indexInPage + 1;
};
export const removePageParam = search => {
  if (!search) return '';
  const newSearch = new URLSearchParams(search);
  newSearch.delete('page');
  const serialized = newSearch.toString();
  return serialized ? `?${serialized}` : '';
};